<template>
    <div id="home" style="flex-grow: 1;" v-loading.fullscreen.lock="changeLoading">
      <Loading :loading="submitLoading" />
      <div style="background-color: white; margin: 10px 20px">
        <div>
          <!--search area-->
          <el-form :inline="true" class="demo-form-inline" ref="searchForm" :rules="searchRules" :model="searchForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('MANUAL.CLIENT')" class="form-label-field" prop="customerName">
                  <el-input @click="showClientNamePop" readonly v-model="searchForm.customerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('MANUAL.GUESTNAME') + ':'" class="form-label-field" style="width:80%;" prop="travelerName">
                  <el-input readonly v-model="searchForm.travelerName" @click="showTravelerNamePop"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="warning" class="harpIDbtn" @click="searchHotel">搜索</el-button>
                  <el-button type="warning" class="harpIDbtn" @click="downloadRoomTypeList">导出</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
               <el-col :span="6">
                <el-form-item label="酒店Id:" prop="hotelId">
                  <el-input v-model="searchForm.hotelId" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="form-label-field" style="width:80%;" prop="dateValue">
                  <el-date-picker v-model="searchForm.dateValue" type="daterange" range-separator="至" start-placeholder="入住时间" end-placeholder="离店时间" class="myinput_inner"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                 <el-form-item prop="cityCode">
                  <destination
                    :returnParentValue="searchForm.cityName"
                    :parentCityCode="searchForm.cityCode"
                    @returnCityInfo="setDestination"
                    :isHotCity="false"
                  ></destination>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div v-if="showTraceId" style="padding: 10px 0;font-size: 14px;">
            TraceId:<span style="color: #fc6640;">{{traceId}}</span>
          </div>
          <div v-if="showNodata" style="padding: 10px 0;font-size: 14px;text-align: center;">
            <span style="color: #fc6640;">未查到酒店房型信息。</span>
          </div>
          <el-table :data="roomTypeList" v-show="roomTypeList.length > 0" border style="margin-top: 15px;">
            <el-table-column prop="roomDescriptiveInfo.id" label="id" align="center"></el-table-column>
            <el-table-column prop="roomDescriptiveInfo.name.zh-CN" label="房型-中文" align="center"></el-table-column>
            <el-table-column prop="roomDescriptiveInfo.name.en" label="房型-英文" align="center"></el-table-column>
            <el-table-column prop="roomDescriptiveInfo.bedTypeCode" :label="$t('DETAIL.BEDTYPE')" align="center">
              <template #default="scope">
                {{ getBedCode(scope.row.roomDescriptiveInfo.bedTypeCode)}}
              </template>
            </el-table-column>
            <el-table-column prop="roomDescriptiveInfo.hasWindow" :label="$t('DETAIL.FACILITES')" align="center">
              <template #default="scope">
                {{
                  scope.row.roomDescriptiveInfo.hasWindow === 0 ? $t('COMMONPARAM.WINDOW.WINDOW0') :
                  scope.row.roomDescriptiveInfo.hasWindow === 1 ? $t('COMMONPARAM.WINDOW.WINDOW1') :
                  scope.row.roomDescriptiveInfo.hasWindow === 2 ? $t('COMMONPARAM.WINDOW.WINDOW2') :
                  scope.row.roomDescriptiveInfo.hasWindow === 3 ? $t('COMMONPARAM.WINDOW.WINDOW3') :
                  scope.row.roomDescriptiveInfo.hasWindow === 4 ? $t('COMMONPARAM.WINDOW.WINDOW4') :
                  scope.row.roomDescriptiveInfo.hasWindow === 5 ? $t('COMMONPARAM.WINDOW.WINDOW5') :
                  scope.row.roomDescriptiveInfo.hasWindow === 6 ? $t('COMMONPARAM.WINDOW.WINDOW6') :
                  ''
                }}
              </template>
            </el-table-column>
            <el-table-column prop="blockReson" label="屏蔽原因" align="center"></el-table-column>
            <el-table-column :label="$t('ORDERLIST.Operation')" fixed="right" width="120"  align="center">
              <template #default="scope">
                <el-button @click="handleDetailClick(scope.row)" type="text" size="small">{{ $t("ORDERLIST.Detail") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- start name dialog -->
      <el-dialog width="90rem" class="dialog-one" v-model="employeeDialogInfo.dialogUserName" :show-close="false">
        <el-tabs v-model="employeeDialogInfo.userActiveName" type="card">
          <el-tab-pane :label="$t('USERDIALOG.TABNAEM1')" name="first">
            <el-row>
              <el-col :span="6" class="search-input">
                <div>{{ $t("USERDIALOG.SEARCHNAME") }}</div>
                <el-input v-model="employeeDialogInfo.searchName"></el-input>
              </el-col>
              <el-col :span="6" class="search-input">
                <div>{{ $t("USERDIALOG.TABLEEMPLOYEEID") }}</div>
                <el-input v-model="employeeDialogInfo.searchEmployeeID"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="search-input">
                <div>{{ $t("USERDIALOG.SEARCHEMAIL") }}</div>
                <el-input v-model="employeeDialogInfo.searchEmail"></el-input>
              </el-col>
              <el-col :span="6" class="search-input">
                <div>{{ $t("USERDIALOG.SEARCHTEL") }}</div>
                <el-input v-model="employeeDialogInfo.searchTel"></el-input>
              </el-col>
              <el-col :span="4" class="search-btn" @click="getTraveler(1)">
                <el-button>{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
              </el-col>
            </el-row>
            <div>
              <Loading :loading="travelerloading" />
              <el-table :data="employeeDialogInfo.employeeData">
                <el-table-column prop="travelerName" :label="$t('USERDIALOG.TABLENAME')" width="150"></el-table-column>
                <el-table-column prop="staffNum" :label="$t('USERDIALOG.TABLEEMPLOYEEID')" width="150"></el-table-column>
                <el-table-column prop="departmentName" :label="$t('USERDIALOG.DEPARTMENT')"></el-table-column>
                <el-table-column prop="mobile" :label="$t('USERDIALOG.TABLETEL')"></el-table-column>
                <el-table-column prop="email" :label="$t('USERDIALOG.SEARCHEMAIL')"></el-table-column>
                <el-table-column width="120" :label="$t('USERDIALOG.OPERATION')">
                  <template #default="scope">
                    <div class="select-btn" @click="selectTraveler(scope.row)">
                      {{ $t("USERDIALOG.SELECT") }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-row style="float: right; margin: 2%">
              <el-pagination background layout="prev, pager, next" :total="employeeDialogInfo.pagination.total" :page-size="employeeDialogInfo.pagination.pageSize" :current-page="employeeDialogInfo.pagination.currentPage" @current-change="pageChange_employeeDialog">
              </el-pagination>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <!-- end name dialog -->  
      <el-dialog v-model="ratePlanDialog" width="90rem" class="dialog-one">
        <div style="display: flex; align-items: center; justify-content: center; height: 3rem;">
          <span style="font-weight: bold; display: flex; align-items: center; height: 100%;">{{ ratePlanTitle }}</span>
        </div>
        <el-divider class="title-divider"></el-divider>
        <el-table :data="ratePlansData" v-show="ratePlansData.length > 0" border style="margin-top: 15px;">
          <el-table-column prop="breakfastInfo.quantity" :label="$t('DETAIL.BREAKFAST')" align="center" sortable>
            <template #default="scope">
              {{scope.row.breakfastInfo.quantity == 0 ? $t("DETAIL.linshi2"):( scope.row.breakfastInfo.quantity == 99 ? $t("DETAIL.HASBREAKFAST") : $t("DETAIL.BREAKFAST") + ' '+'x'+' ' + scope.row.breakfastInfo.quantity)}}
            </template>
          </el-table-column>
          <el-table-column prop="source" label="source" align="center" sortable></el-table-column>
          <el-table-column prop="paymentType" :label="$t('RESULT.PAYMENT')" align="center" sortable>
            <template #default="scope">
              {{
                scope.row.paymentType === 1 ? $t('DETAIL.PAYMENTTYPE1') :
                scope.row.paymentType === 2 ? $t('DETAIL.PAYMENTTYPE2') :
                scope.row.paymentType === 3 ? $t('DETAIL.PAYMENTTYPE3') :
                ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="averagePrice" label="价格" align="center" sortable>
            <template #default="scope">
              {{scope.row.averagePrice ? (($currencySign[scope.row.currencyCode]?$currencySign[scope.row.currencyCode]:scope.row.currencyCode) + scope.row.averagePrice) :'N/A' }}
              <span v-if=" scope.row.hasTax" style="font-size:12px">({{ $t("DETAIL.TAXIN") }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="negotiationPriceType" label="协议价格类型" align="center"></el-table-column>
          <el-table-column prop="priceOwner" label="价格所属" align="center"></el-table-column>
          <el-table-column prop="blockReson" label="屏蔽原因" align="center"></el-table-column>
        </el-table>
      </el-dialog>
      <ConfirmBoxs
        :centerDialogVisible="confirmFlag"
        :confirmMsg="confirmMsg"
        @setConfirmFlag="setConfirmFlag"
      ></ConfirmBoxs>
      <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
    </div>
  </template>
    
    <script>
  import { availabilityroomtypes,roomTypeDownLoadExcel } from "@/api/shoppingData";
  import { travelerLookup } from "@/api/platformData";
  import Loading from "@/components/Loading.vue";
  import ConfirmBoxs from "@/components/confirmBoxs.vue";
  import DatePicker from "@/components/DatePicker.vue";
  import { formatDateTime,getFileName } from "@/utils/utils.js";
  import Destination from "@/components/Destination.vue";
  import ClientList from "@/components/ClientList.vue";
  import { getDictionaryItem } from "@/utils/getDictionaryData.js";
  export default {
    name: "HBEHotelRoomTypesData",
    components: {
      DatePicker,
      ConfirmBoxs,
      Loading,
      Destination,
      ClientList
    },
    data() {
      return {
        clientListFlag: false,
        ratePlanDialog:false,
        showTraceId: false,
        showNodata: false,
        travelerloading: false,
        changeLoading: false,
        tableData: [],
        confirmMsg: "",
        confirmFlag: false,
        submitLoading: false,
        searchForm: {
          posCode:"",
          customerName: "",
          travelerName: "",
          bookingContactId: "", 
          hotelId: "", //酒店ID
          dateValue: '',
          checkInDate: "",
          checkOutDate: "",
          cityName: "",
          cityCode: "",
          countryCode: "",
        },
        roomTypeList: [],
        ratePlansData:[],
        traceId: "",
        ratePlanTitle: "",
        employeeDialogInfo: {
          dialogUserName: false,
          userActiveName: "first",
          searchName: "", //name search
          searchEmployeeID: "", //tel search
          searchEmail: "", //name search
          searchTel: "", //tel search
          employeeData: [],
          pagination: {
            total: 0, //总数
            pageSize: 5,
            currentPage: 1
          }, //分页信息
        },
      };
    },
    computed: {
      searchRules() {
        return {
          "customerName": [{ required: true, message: this.$t("MANUAL.VALIDATECUSTOMERNAME"), trigger: ["blur", "change"], }],
          "travelerName": [{ required: true, message: this.$t("MANUAL.VALIDATETRAVELERNAME"), trigger: ["blur", "change"], }],
          "dateValue": [{ required: true, message: "请输入入离时间", trigger: ["blur", "change"], }],
          "hotelId": [{ required: true, message: "请输入酒店ID", trigger: ["blur", "change"], }],
          "cityCode": [{ required: true, message: "请输入城市信息", trigger: ["blur", "change"], }],
        }
      },
    },
    methods: {
      getBedCode(item) {
        return getDictionaryItem(item,'bedtype')[this.$t("DETAIL.RESPONSEDATA.bedtype")] || 'N/A';
      },
      //搜索button
      async searchHotel() {
        this.$refs["searchForm"].validate(async (valid) => {
          if (valid) {
            this.searchForm.checkInDate = formatDateTime(this.searchForm.dateValue[0],"YYYY-MM-DD");
            this.searchForm.checkOutDate = formatDateTime(this.searchForm.dateValue[1],"YYYY-MM-DD");
            this.submitLoading = true;
            await this.getHotelRoomTypeList();// 获取FX动态酒店列表信息hotels/search接口
            this.submitLoading = false;
          }
        });
      },
      async getHotelRoomTypeList() {
        let Hotelparams = {
          posCode: this.searchForm.posCode, //公司代码
          hotelCode: this.searchForm.hotelId, //酒店ID
          checkInDate: this.searchForm.checkInDate,
          checkOutDate: this.searchForm.checkOutDate,
          countryCode: this.searchForm.countryCode, //国家代码
          cwtCityCode: this.searchForm.cityCode, //城市代码
          source: "CRM",
          noGuests: "1",
          noRooms: "1",
          bookingContactId: this.searchForm.bookingContactId, //入住人ID
        };
        let that = this;
        await availabilityroomtypes(Hotelparams)
          .then((res) => {
            that.showTraceId = true;
            that.traceId = res.data.traceId;
            if (res.data.error.code != 0) {
              that.showNodata = true;
            } else {
              that.roomTypeList = res.data.roomTypeList;
              that.showNodata = res.data.roomTypeList.length == 0 ? true : false;
            }
          })
          .catch(function (error) {
            console.log("酒店信息 请求失败", error.objError);
          });
      },
      downloadRoomTypeList(){
        this.$refs["searchForm"].validate(async (valid) => {
          if (valid) {
            this.searchForm.checkInDate = formatDateTime(this.searchForm.dateValue[0],"YYYY-MM-DD");
            this.searchForm.checkOutDate = formatDateTime(this.searchForm.dateValue[1],"YYYY-MM-DD");
            this.submitLoading = true;
            this.getRoomTypeExcel();
            this.submitLoading = false;
          }
        });
      },
      getRoomTypeExcel(){
        let params = {
          posCode: this.searchForm.posCode, //公司代码
          hotelCode: this.searchForm.hotelId, //酒店ID
          checkInDate: this.searchForm.checkInDate,
          checkOutDate: this.searchForm.checkOutDate,
          source: "CRM",
          noGuests: "1",
          noRooms: "1",
          bookingContactId: this.searchForm.bookingContactId, //入住人ID
        };
        roomTypeDownLoadExcel(params)
        .then((res) => {
           // 执行下载
          const downloadLink = document.createElement("a");
          // 设置下载文件名
          const fileName = getFileName();
          // .csv 文件后缀
          downloadLink.download = fileName + ".xls"; // 文件名称
          downloadLink.style.display = "none";
          //csv文件的type  text/csv    xls:application/vnd.ms-excel
          const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); //字节转成 Blob
          downloadLink.href = URL.createObjectURL(blob);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        })
        .catch((error) => {
          console.log("导出Excel", error);
        });
      },
      setConfirmFlag(value) {
        this.changeLoading = false;
        this.confirmFlag = value;
      },
      // 弹出客户姓名窗口方法
      showClientNamePop() {
        this.clientListFlag = true;
      },
      setCustomerFlag(value) {
        this.clientListFlag = value;
      },
      //选择客户
      selectClient(item) {
        if (this.searchForm.posCode != item.customerCode) {
          this.searchForm.travelerName = '';
          this.searchForm.bookingContactId = '';
        }
        this.searchForm.customerName = item.customerName;
        this.searchForm.posCode = item.customerCode;
        // 根据view权限获取员工信息
        this.getTraveler(1);
      },
      // 弹出入住人姓名窗口方法
      showTravelerNamePop() {
        this.employeeDialogInfo.dialogUserName = true;
      },
      //获取出行人信息
      async getTraveler(currPage) {
        this.travelerloading = true;
        let tranlerParam = {
          params: {
            page: currPage,
            per_page: 5,
            travelerName: this.employeeDialogInfo.searchName,
            mobile: this.employeeDialogInfo.searchTel,
            staffNum: this.employeeDialogInfo.searchEmployeeID,
            email: this.employeeDialogInfo.searchEmail,
            companyCode: this.searchForm.posCode,
          },
        };
        let that = this;
        await travelerLookup(tranlerParam)
          .then((res) => {
            if (res.data) {
              that.employeeDialogInfo.pagination.total = res.data.total; //总数
              that.employeeDialogInfo.pagination.pageSize = res.data.pageSize;
              that.employeeDialogInfo.pagination.currentPage = res.data.pageNumber;
              that.employeeDialogInfo.employeeData = res.data.travelerList;
            }
            this.travelerloading = false;
          })
          .catch(function (error) {
            this.travelerloading = false;
            console.log("出行人信息 请求失败", error.objError);
          });
      },
      //选择入住人
      selectTraveler(item) {
        this.employeeDialogInfo.dialogUserName = false;
        this.searchForm.travelerName = item.travelerName;
        this.searchForm.bookingContactId = item.travelerCode;
      },
      //员工列表分页切换
      pageChange_employeeDialog(currPage) {
        this.getTraveler(currPage);
      },
      handleDetailClick(row) {
        this.ratePlanDialog = true;
        this.ratePlanTitle = row.roomDescriptiveInfo.name["zh-CN"] + ' - ' + "详情";
        this.ratePlansData = row.ratePlans;
      },
       // 子组件赋值目的城市 destination组件
      setDestination(value) {
        if (value.cityInfo) {
          this.searchForm.cityCode = value.cityInfo.cityCode;
          this.searchForm.countryCode = value.cityInfo.countryCode;
        }else {
          this.searchForm.cityCode = '';
          this.searchForm.countryCode = '';
        }
      },
    },
  };
  </script>
    
    <style scoped>
  .loading {
    z-index: 999999;
  }
  .paginationsty {
    float: right;
    margin: 1rem 0;
  }
  .harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  .demo-form-inline{
    margin-left: 6rem;
    padding-top: 2rem
  }
  .title-divider {
    height: 2px;
    margin: 10px 0 0 0;
    background-color: #fc6640;
  }
  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }
  ::v-deep .el-tabs__item.is-active {
    background: #efc4ba;
    color: #000;
    padding-right: 10px;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fc6640;
  }
  ::v-deep .el-input__inner {
    height: 3rem;
    line-height: 2.7rem;
  }
  ::v-deep .dialog-one .el-dialog__header, ::v-deep .dialog-one .el-tabs__active-bar {
    display: none;
  }
  .search-input {
    margin-left: 10%;
  }
  .search-btn {
    margin: 2% 5%;
  }
  .search-btn button {
    padding: 7px 20px;
    border: 1px solid #fc6640;
    color: #fc6640;
    background: transparent;
    cursor: pointer;
  }
  .select-btn {
    color: #fc6640;
    cursor: pointer;
  }
  .myinput_inner {
    height: 4rem;
  }
  </style>
